import { createAction, props } from '@ngrx/store';
import { PesquisaBasicaJornalInputDto } from 'src/app/domain/DTOs/input/pesquisa-basica-jornal.input.dto';
import { EstruturaRetornoDadosPaginadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados-paginados.output.dto';
import { EstruturaRetornoOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno.output.dto';
import { ResultadoPesquisaJornalOutputDto } from 'src/app/domain/DTOs/output/jornal/resultado-pesquisa-jornal.output.dto';

const actionName = "[ PesquisarJornalPaginado ] Pesquisar jornais paginados";

export const pesquisarJornalPaginado = createAction(
  actionName,
  props<{ inputDto: PesquisaBasicaJornalInputDto}>()
);

export const pesquisarJornalPaginadoSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosPaginadosOutputDto<ResultadoPesquisaJornalOutputDto[]> }>()
);

export const pesquisarJornalPaginadoFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosPaginadosOutputDto<ResultadoPesquisaJornalOutputDto[]> }>()
);

export const pesquisarJornalPaginadoCatchError = createAction(
  `${actionName} - Falha - CatchError`,
  props<{ response: EstruturaRetornoOutputDto }>()
);

export const pesquisarJornalPaginadoFinish = createAction(
  `${actionName} - Concluir`
);
